export function sanityImagePlaceholder(
	url: string | null | undefined,
	opts: { w?: number; h?: number; q?: number } = {},
): string {
	if (!url) return '';
	const { w = 20, h = 20, q = 20 } = opts;
	const base = url.split('?')[0];
	return `${base}?w=${w}&h=${h}&q=${q}&fit=crop&auto=format`;
}
